import React, { createContext, useState, useContext, memo } from "react";
import Toast from 'da-frontend-shared-ui-components/lib/Toast'

const DefaultMessage = {
  message: "",
  open: false
}

// Toast Context
const ToastContext = createContext<[typeof DefaultMessage, (state: typeof DefaultMessage) => void]>([ DefaultMessage, null ]);

/** Toast Hook */
const useToast = () => {
  const [ , dispatch ] = useContext(ToastContext);

  return {
    sendToast: (message: string) => dispatch({ message, open: true })
  }
}

const ToastDisplay = memo(() => {
  const [ state, dispatch ] = useContext(ToastContext);
  const { message, open } = state;

  return (
    <Toast message={message} open={open} onClose={() => dispatch({ message, open: false })} />
  );
})

/** Toast Provider */
const ToastProvider = ({ children }: { children?: React.ReactNode }) => {
  const toastState = useState(DefaultMessage);

  return (
    <ToastContext.Provider value={ toastState }>
      {children}
      <ToastDisplay />
    </ToastContext.Provider>
  )
}

export {
  useToast,
  ToastProvider
}